// import axios from 'axios'
// import { AppUrl } from '@/assets/js/variables'

const state = {
  userInfo: {
    name: 'Tom Nikoleris'
  },
  salesTraffic: {
    chartOptions: {
      series: [{
        name: 'Products',
        data: [222, 249, 80, 785, 631, 352, 99, 830, 887, 1272, 883, 743, 508, 373, 839, 776, 789, 731, 588, 455, 399, 944, 750, 643, 840, 767, 393, 427, 647, 726]
      }],
      chart: {
        id: 'availability-tracking-chart',
        toolbar: {
          show: false
        }
      },
      legend: {
        show: false
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        lineCap: 'butt',
        curve: 'smooth',
        colors: undefined,
        width: 2.5,
        dashArray: 0
      },
      fill: {
        colors: ['#307fff', '#04d79c', '#745af2'],
        type: 'gradient',
        gradient: {
          shade: 'dark',
          type: 'vertical',
          shadeIntensity: 0.2,
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0,
          stops: [0, 150]
        }
      },
      grid: {
        strokeDashArray: 3
      },
      xaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false
        },
        categories: ['28 17:00', '28 18:00', '28 19:00', '28 20:00', '28 21:00', '28 22:00', '28 23:00', '29 00:00', '29 01:00', '29 02:00', '29 03:00', '29 04:00', '29 05:00', '29 06:00', '29 07:00', '29 08:00', '29 09:00', '29 10:00', '29 11:00', '29 12:00', '29 13:00', '29 14:00', '29 15:00', '29 16:00']
      },
      yaxis: {
        show: true,
        showAlways: true,
        seriesName: 'Products',
        opposite: false,
        reversed: false,
        logarithmic: false,
        tickAmount: 5,
        min: 0,
        forceNiceScale: false,
        floating: false,
        decimalsInFloat: 2,
        labels: {
          show: true,
          align: 'right',
          minWidth: 0,
          offsetX: -20,
          offsetY: 0
        },
        axisBorder: {
          show: false
        }
      },
      tooltip: {
        show: false,
        x: {
          format: 'dd'
        },
        y: {
          show: false
        }
      }
    }
  }
}

const getters = {

}

const actions = {

}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js